let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3x2tH")).then(() => parcelRequire('gUv1l'));